import toolkitApi, { toolkitSimpleTransform } from '../../toolkitApi';

const endpoint =
    '/site/api/game-winning-goals-stanley-cup?sort=seasonId&dir=DESC' +
    '&include=winningTeam.commonName' +
    '&include=winningTeam.fullName' +
    '&include=winningTeam.placeName' +
    '&include=winningTeam.triCode' +
    '&include=winningTeam.logos' +
    '&include=losingTeam.commonName' +
    '&include=losingTeam.fullName' +
    '&include=losingTeam.placeName' +
    '&include=losingTeam.triCode' +
    '&include=losingTeam.logos';

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        gameWinningGoalsStanleyCup: build.query({
            query: () => ({
                url: endpoint,
            }),
            transformResponse: toolkitSimpleTransform,
        }),
    }),
});
